// MessageChat.js
import React, { useRef, useEffect, useState } from 'react';
import { MdAttachFile, MdSend} from "react-icons/md";
import "./orderNoteMessage.css"; // le CSS à créer
import SwiperEffectCards from '../slider/swiperEffectCards';
import ShowimagesLoading from './showImagesLoading';

// import { useSocket } from '../auth/SocketContext';
import {
    AddImgGraphicOrder
} from "../auth/apiProduct";
import {updateMessageOrder} from "../auth";

// function MessageInputWithImage() {
//   const [text, setText] = useState("");
//   const [images, setImages] = useState([]);

//   const handleImageChange = (e) => {
//     const files = Array.from(e.target.files);
//     setImages((prev) => [...prev, ...files]);
//   };

//   const handleSubmit = () => {
//     const message = {
//       text,
//       images,
//     };
//     // ici tu peux envoyer via API ou stocker dans MongoDB etc.
//   };

//   return (
//     <div className="form-group">
//       <textarea
//         className="form-control mb-2"
//         placeholder="Write your message..."
//         value={text}
//         onChange={(e) => setText(e.target.value)}
//         rows={text.split("\n")?.length || 1}
//         style={{ resize: "none" }}
//       />

//       <input
//         type="file"
//         accept="image/*"
//         multiple
//         onChange={handleImageChange}
//         className="form-control mb-2"
//       />

//       {images?.length > 0 && (
//         <div className="mb-2">
//           {images?.map((img, idx) => (
//             <p key={idx}>{img.name}</p>
//           ))}
//         </div>
//       )}

//       <button onClick={handleSubmit} className="btn btn-primary">
//         Send Message
//       </button>
//     </div>
//   );
// }

const  finalizeIndexes = ([start, length]) => {
  if (typeof start !== "number" || typeof length !== "number") {
    throw new Error("L'entrée doit être un tableau contenant [startIndex, length]");
  }
  return Array.from({ length }, (_, i) => start + i);
  // Résultat : [0, 4] → [0, 1, 2, 3]
}

const splitArrayByIndexes = (array, chunkSize) => {
  if (!Array.isArray(array)) throw new Error("Le premier argument doit être un tableau");
  if (typeof chunkSize !== "number" || chunkSize < 0) throw new Error("chunkSize doit être un entier positif ou zéro");

  const indexes = Array.from(array.keys()); // [0, 1, 2, ..., array?.length - 1]

  const firstIndexes = indexes.slice(0, chunkSize);
  const secondIndexes = indexes.slice(chunkSize);

  return [firstIndexes, secondIndexes,  [firstIndexes?.length, secondIndexes?.length], [0, array?.length]];
  // arr = ['a', 'b', 'c', 'd', 'e'];
  // Résultat : [ [0, 1], [2, 3, 4],[2, 3], [0, 5] ]
}

const flattenCustomerArrays = (data, user ='custormer') => {
  // Résultat :
/*
[0, 1, 2, 3, 4]
*/
  return data
    .filter(item => Array.isArray(item[user])) // garde seulement les objets avec des tableaux
    .flatMap(item => item[user]);              // fusionne tous les éléments dans un seul tableau
}

const getOnlyCustomerArrays = (data, user ='custormer') =>{
// Résultat :
/*
[
  [0],
  [1, 2, 3]
]
*/
  return data
    .filter(item => Array.isArray(item[user]))
    ?.map(item => item[user]);
}

const OrderNoteMessage = ({ graphicNoteBs = [
  // Bloc 1
  { custormer: "Can I add my logo on the front of the t-shirt?" },
  { custormer: "Do you support transparent PNG files for uploads?" },
  { seller: "Yes, you can add your logo. We do accept transparent PNG files for best quality." },

  // Bloc 2
  { custormer: "Can you suggest a font that fits an urban streetwear style?" },
  { seller: "Sure! We recommend 'Anton' or 'Bebas Neue' for bold urban streetwear looks." },

  // Bloc 3
  { custormer: "Can I combine text and image in one design?" },
  { custormer: "Do you align it manually or is it automatic?" },
  { seller: "Yes, we combine them manually to ensure proper alignment and visual balance." },

  // Bloc 4
  { custormer: "Can you show a preview before printing?" },
  { custormer: "Do you offer revision if the first design doesn’t match my vision?" },
  { seller: "Yes, we provide a preview and allow one free revision if needed before final approval." }
], 
token,
orderID,
graphicImgBs,
setGraphicNoteBs,
infoSource, 
setGraphicNote, 
graphicNote, 
onFileSelect,
maxImgSize = 4,
imgSize,
pageImgSms, 
ust = 'c',
userSend = 'custormer'
}) => {
   const divSms = useRef(null);
  const connRef = useRef(null);

    // const socket = useSocket();
    const scrollToParagraph = (ref) => {
         if (ref && ref.current) {
    ref.current.scrollIntoView({ behavior: 'smooth' });
  }
      };

    const createArrayNum = (s, e) => {
  const array = [];
  for (let i = s; i <= e; i++) {
    array.push(i);
  }
  return array;
}

 const textareaRef = useRef();
const fileInputRef = useRef(null);
const[post, setPost]=useState({
    title:"",
    desc:"",
   photos:[]
})
const [error, setError] = useState(null);

const {title, desc, photos} = post
let sizeImg =  photos?.length + imgSize 

const handleFiles=(files)=>{
    let arrPhotos = [];
    let sizeArr
    for (let file of files){
        
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.addEventListener('load', ()=>{
            let fileobj ={
                file: file,
                name : file.name,
                type: file.type,
                size: file.size,
                src: reader.result
            }
        arrPhotos.push(fileobj)
        if(( sizeImg+ files?.length) > maxImgSize){
            sizeArr = files?.length -  ((sizeImg + files?.length) - maxImgSize)
        }else{
            sizeArr =   files?.length
        }
        setPost({
            ...post,
            photos:[...photos, ...arrPhotos.slice(0, sizeArr)]
        })
        });
    }
}
const handledelete = e =>{
    let target = e.target.parentElement;
    // 
    let tagetIndex = target.dataset.imgindex * 1;
setPost({
...post,
photos:[...photos.slice(0, tagetIndex), ...photos.slice(tagetIndex + 1)]
})
    
}
 const handleImsOderGraphic = async (token, order_id) => {
   let messageOrder = []
   if(ust === 'c'){
      graphicNote && messageOrder.push({custormer: graphicNote})
   photos?.length > 0 &&  messageOrder.push({custormer: [graphicImgBs.galeriesC?.length, photos?.length]})
   }

   if(ust === 's'){
      graphicNote && messageOrder.push({seller: graphicNote})
   photos?.length > 0 &&  messageOrder.push({seller: [graphicImgBs.galeriesS?.length, photos?.length] })
   }

  (graphicNote !== ''|| photos?.length > 0) && await updateMessageOrder(token, order_id, messageOrder).then(data => {
        if (data.error) {
             setError(data.error)
        } else {
        setGraphicNoteBs(data)
             setError(null)
        setGraphicNote("")
        }
    })
   
       // Sequential uploads (UP-08): the previous `await photos.map(...)`
       // neither waited nor limited concurrency.
       for (const f of photos || []) {
        const data = await AddImgGraphicOrder(token, order_id, f.file, ust);
        if (data.error) {
             setError(data.error)
             break;
        }
        setError(null)
        setPost({
        title:"",
        desc:"",
         photos:[]
        })
       }
    setTimeout(() => {
scrollToParagraph(divSms)
    }, 100)
    }


  useEffect(() => {
    const messageId = orderID


    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
        setTimeout(() => {
scrollToParagraph(divSms)
    }, 100)
  }, [graphicNote, orderID]);

 const handleButtonClick = () => {
    fileInputRef.current.click(); // Clique le vrai input
  };

  const handleFileChange = (e) => {
  let files = e.target.files;
    handleFiles(files);
  };


const handlehighlight = e =>{
e.preventDefault();
e.stopPropagation();
// setHighlight(true);
}

const handleunhighlight = e =>{
    e.preventDefault();
    e.stopPropagation();
    // setHighlight(false);
}

const handledrop = e =>{
    e.preventDefault();
    e.stopPropagation();
    // setHighlight(false);
    let dt = e.dataTransfer;
    let files = dt.files
    handleFiles(files)
}

      const handleChange = (index, value) => {
    const updated = [...graphicNote];
    const key = Object.keys(updated[index])[0];

    // Allow change only if not the second line
    if (index !== 1) {
      updated[index][key] = value;
      setGraphicNote(updated);
    }
  };

  const handleKeyDown = (e, token, orderID) => {
    if (e.key === "Enter") {
      e.preventDefault();
    //   const current = graphicNote[index];
    //   const key = Object.keys(current)[0];
      if (graphicNote.trim() !== "" || photos?.length !== 0) {
        handleImsOderGraphic(token, orderID)
        // setGraphicNote([...graphicNote, { custormer: "" }]);
      }
    }
  };

  const imagesSeletCSS =(a = 0)=>{
       
    let x = {
        border: "2px solid green",
    }
 
    let y = {
        border: "4px solid red",
    }

   return 2000000 < a ? y : x
   
}

// const smsNOte = flattenCustomerArrays(graphicNoteBs.messageOrder,  'custormer')
  return (
    <div className="message-input"
      onDragEnter={handlehighlight}
                onDragOver={handlehighlight}
                onDragLeave={handleunhighlight}
                onDrop={handledrop}
    >
   {!pageImgSms &&
    <div className="chat-container">
      {graphicNoteBs && graphicNoteBs.messageOrder && graphicNoteBs.messageOrder?.length > 0 && graphicNoteBs.messageOrder?.map((msg, index) => {
        const key = Object.keys(msg)[0];
        const text = msg[key];
        const isMe = key === userSend;
        return (
      
          <div
            key={index}
            className={`message ${isMe ? "custormer" : "seller"}`}
          >
            {(Array.isArray(text))?
<SwiperEffectCards
pathUrl= {key === "custormer" ? graphicNoteBs.urlImgcustomerGraphic: graphicNoteBs.urlImgsellerGraphic}
graphicImgBs = { finalizeIndexes(text)}
el={true}
infoSource={infoSource}
 />
            :
            <span>{text}</span>
      }
          </div>
        );
      })}
      <div ref={divSms} />
      
      </div>}

        {pageImgSms &&
    <div className="chat-container">
{graphicImgBs && graphicImgBs.galeriesC?.length > 0 && <div className={`message  custormer`}>
<SwiperEffectCards
pathUrl= {graphicNoteBs.urlImgcustomerGraphic}
graphicImgBs = {graphicImgBs.galeriesC}
infoSource={infoSource}
 />
</div>}

{graphicImgBs && graphicImgBs.galeriesS?.length > 0 &&  <div className={`message  seller`}>
<SwiperEffectCards
pathUrl= {graphicNoteBs.urlImgsellerGraphic}
graphicImgBs = {graphicImgBs.galeriesS}
infoSource={infoSource}
/>
</div>}
      </div>}

          <div className="form-group">
              <div className="custom-file-preview" >
                  {photos?.length > 0 && photos?.map((a, i) =>(
                    <div className="prev-img" key={i} data-imgindex={i} style={imagesSeletCSS(a.size)}>
                        <span onClick={handledelete}>&times;</span>
                        <ShowimagesLoading className="imgLoad" src={a.src} alt={a.name}/>
                    </div>
                    ))}
                </div>
              <div className={ ""} 
              
                >
      {/* Bouton avec icône */}
     {photos?.length <= 4 && <button type="button"
      className='text-dark m-2 h3 float-left'
       onClick={handleButtonClick}
        style={{ background: "none", border: "none" }}>
        <MdAttachFile size={24} />
      </button>}

      {/* Input masqué */}
      <input
        type="file"
        name="photos"
        multiple 
        id="filephotos"
        onKeyDown={(e) =>handleKeyDown(e, token, orderID)}
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
        accept="image/*" // ou autre selon le type de fichier
      />
<button type="button" className='text-primary m-2 h3 float-right'  onClick={()=>handleImsOderGraphic(token, orderID)}
        style={{ background: "none", border: "none" }}><MdSend /></button>
     <textarea
      ref={textareaRef}
        onKeyDown={(e) =>handleKeyDown(e, token, orderID)}
      className="form-control mb-2"
      value={graphicNote}
      onChange={(e) => setGraphicNote(e.target.value)}
      style={{ overflow: "hidden", resize: "none" }}
    />
   
      </div>
    </div>
    </div>
  );
};

export default OrderNoteMessage;